module.exports = __webpack_public_path__ + "static/media/coin.512f2dcc.png";